import React, { Fragment } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import LoyaltyUserSummary from 'components/loyalty/userSummary';
import { TextButton } from 'scy/buttons';
import { H5 } from 'scy/text';
import { mutedAccent } from 'scy/text/styles.mod.scss';
import { block } from 'scy/display.mod.scss';
import padding from 'scy/padding.mod.scss';
import border from 'scy/border.mod.scss';

function NavLink({ children, ...props }) {
  return (
    <H5
      uppercase
      className={classnames(
        padding.left_xs,
        padding.right_xs,
        border.top,
        mutedAccent
      )}
    >
      <a className={classnames(block, padding.sm)} {...props}>
        {children}
      </a>
    </H5>
  );
}

export default function UserMenu({
  currentPoints,
  currentStatus,
  nextStatus,
  user,
  showOrders,
  logout,
  close,
  loadingLoyaltyData
}) {
  return (
    <Fragment>
      <div className={padding.sm}>
        <Link to="/loyalty" onClick={close}>
          <LoyaltyUserSummary
            currentPoints={currentPoints}
            currentStatus={currentStatus}
            nextStatus={nextStatus}
            user={user}
            loading={loadingLoyaltyData}
          />
        </Link>
      </div>

      <NavLink href="/share">Invite Friends</NavLink>

      <NavLink href="/account">Your Account</NavLink>

      {showOrders && <NavLink href="/orders">Your Orders</NavLink>}

      <NavLink
        target="_blank"
        rel="noreferrer noopener"
        href="http://help.sauceyapp.com/"
      >
        FAQs
      </NavLink>

      <H5
        uppercase
        tag="div"
        className={classnames(padding.left_xs, padding.right_xs, border.top)}
      >
        <TextButton noUnderline className={padding.sm} onClick={logout}>
          Logout
        </TextButton>
      </H5>
    </Fragment>
  );
}
